import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import Buttons from "../../../components/ui/button/Buttons";
import { AppIcons } from "../../../data/appIcons";
import BoardCommitteeList from "../component/BoardCommitteeList";

const initState = {
    comments: "",
    deadline: "",
    additionalNotes: "",
    boardApprovalDate: "",
};

export const BoardcommitteeApprovalFormData = {
    name: "BoardcommitteeApprovalFormData",
    initialState: initState,
    section: [
        {
            title: "",
            row: {},
            style: {
                sectionStyle: "mb-3 card-form row",
            },

            fields: [
                {
                    id: "comments",
                    label: "Comments",
                    Field_Name: "Comments",
                    fieldType: FormFieldTypes.TEXTAREA,
                    dataField: "comments",
                    fieldSetting: {
                        placeholder: "Please Enter Comment",
                        allowSpace: true,
                        textareaRows: 4,
                        maxLength: 1000,
                        showCharacterLength: true
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss:
                            "col-lg-9 col-md-9  validation-left-0 text-area-full",
                    },
                },
                {
                    id: "deadline",
                    label: "Deadline",
                    Field_Name: "Deadline",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "deadline",
                    fieldSetting: {
                        allowSpace: true,
                        placeholder: "Select",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-9 col-md-9  validation-left-0 mb-2",
                    },
                },
                {
                    id: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.DATEPICKER,
                    label: "",
                    dataField: "",
                    fieldSetting: {
                        isDisable: false,
                        isFormControl: true,
                        isTemplateBtnDisable: false,
                        formControltemplate: (
                            <Buttons
                                actionName={"SEND_FOR_APPROVAL"}
                                buttonText={"Send for Approval"}
                                buttonTypeClassName="outline-theme-btn right-side-form-btn"
                                isTextWithIcon={true}
                                btnIcon={AppIcons.plusIcon} // Attach the dynamic onClick handler here
                            />
                        ),
                    },
                    style: {
                        containerCss: "col-lg-3 col-md-3 blank-field blank-field-with-btn",
                    },
                },
                {
                    id: "",
                    label: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.SEPARATOR,
                    fieldSetting: {
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-lg-12 col-md-12  ",
                    },
                },
                {
                    id: "",
                    label: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "deadline",
                    fieldSetting: {
                        isFormControl: true,
                        formControltemplate: <BoardCommitteeList />,
                    },
                    style: {
                        containerCss:
                            "col-lg-12 col-md-12  validation-left-0 mb-2 blank-field-custom-grid",
                    },
                },
                {
                    id: "additionalNotes",
                    label: "Additional Notes",
                    Field_Name: "Additional Notes",
                    fieldType: FormFieldTypes.TEXTAREA,
                    dataField: "additionalNotes",
                    fieldSetting: {
                        placeholder: "Please Enter Comment",
                        allowSpace: true,
                        textareaRows: 4,
                        maxLength: 1000,
                        showCharacterLength: true
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss:
                            "col-lg-9 col-md-9  validation-left-0 text-area-full",
                    },
                },
                {
                    id: "boardApprovalDate",
                    label: "Board of Directors Approval Date.",
                    Field_Name: "Board of Directors Approval Date.",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "boardApprovalDate",
                    fieldSetting: {
                        allowSpace: true,
                        placeholder: "Select",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-9 col-md-9  validation-left-0 mb-2",
                    },
                },
                {
                    id: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.DATEPICKER,
                    label: "",
                    dataField: "",
                    fieldSetting: {
                        isDisable: false,
                        isFormControl: true,
                        isTemplateBtnDisable: false,
                        formControltemplate: (
                            <Buttons
                                actionName={"SUBMIT"}
                                buttonText={"Submit"}
                                buttonTypeClassName="theme-btn right-side-form-btn"
                                isTextWithIcon={true}
                                btnIcon={AppIcons.plusIcon} // Attach the dynamic onClick handler here
                            />
                        ),
                    },
                    style: {
                        containerCss: "col-lg-3 col-md-3 blank-field blank-field-with-btn",
                    },
                },
            ],
        },
    ],
    formSetting: {
        isViewOnly: false,
    }
};
